import { render, staticRenderFns } from "./RmpiReport.vue?vue&type=template&id=edca1358&"
import script from "./RmpiReport.vue?vue&type=script&lang=js&"
export * from "./RmpiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports